interface Props {
  [key: string]: any
}

function AimIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M7.96 17.52V15.92C6.29333 15.7333 4.86333 15.0433 3.67 13.85C2.47667 12.6567 1.78667 11.2267 1.6 9.56H0V7.96H1.6C1.78667 6.29333 2.47667 4.86333 3.67 3.67C4.86333 2.47667 6.29333 1.78667 7.96 1.6V0H9.56V1.6C11.2267 1.78667 12.6567 2.47667 13.85 3.67C15.0433 4.86333 15.7333 6.29333 15.92 7.96H17.52V9.56H15.92C15.7333 11.2267 15.0433 12.6567 13.85 13.85C12.6567 15.0433 11.2267 15.7333 9.56 15.92V17.52H7.96ZM8.76 14.36C10.3067 14.36 11.6267 13.8133 12.72 12.72C13.8133 11.6267 14.36 10.3067 14.36 8.76C14.36 7.21333 13.8133 5.89333 12.72 4.8C11.6267 3.70667 10.3067 3.16 8.76 3.16C7.21333 3.16 5.89333 3.70667 4.8 4.8C3.70667 5.89333 3.16 7.21333 3.16 8.76C3.16 10.3067 3.70667 11.6267 4.8 12.72C5.89333 13.8133 7.21333 14.36 8.76 14.36ZM8.76 11.96C7.88 11.96 7.12667 11.6467 6.5 11.02C5.87333 10.3933 5.56 9.64 5.56 8.76C5.56 7.88 5.87333 7.12667 6.5 6.5C7.12667 5.87333 7.88 5.56 8.76 5.56C9.64 5.56 10.3933 5.87333 11.02 6.5C11.6467 7.12667 11.96 7.88 11.96 8.76C11.96 9.64 11.6467 10.3933 11.02 11.02C10.3933 11.6467 9.64 11.96 8.76 11.96Z"
        fill="#E3FFA0"
      />
    </svg>
  )
}

export default AimIcon
